import { useEffect, useRef, useState } from "react";

export const EASE = [0.16, 1, 0.3, 1];
const EASE_CSS = "cubic-bezier(0.16, 1, 0.3, 1)";

const useSeen = (margin = "-8% 0px") => {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { rootMargin: margin }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [margin]);
  return [ref, seen];
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => {
  const [ref, seen] = useSeen();
  return (
    <span ref={ref} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
      <span
        className={`block will-change-transform transition-transform duration-[1000ms] ${
          seen ? "translate-y-0" : "translate-y-[115%]"
        } ${className}`}
        style={{ transitionDelay: `${delay}s`, transitionTimingFunction: EASE_CSS }}
      >
        {children}
      </span>
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 28, margin = "-10% 0px" }) => {
  const [ref, seen] = useSeen(margin);
  return (
    <div
      ref={ref}
      className={`${className} transition-[opacity,transform] duration-[900ms] will-change-transform`}
      style={{
        opacity: seen ? 1 : 0,
        transform: seen ? "translateY(0px)" : `translateY(${y}px)`,
        transitionDelay: `${delay}s`,
        transitionTimingFunction: EASE_CSS,
      }}
    >
      {children}
    </div>
  );
};
